const normalizeScriptPath = (urlValue) => {
    if (!urlValue) return '';
    try {
        return new URL(urlValue, window.location.origin).pathname;
    } catch (error) {
        return String(urlValue).split('?')[0];
    }
}

const getCurrentLoadedScriptPaths = () => {
    try {
        const scriptEntries = performance.getEntriesByType('resource')
            .filter((entry) => entry.initiatorType === 'script')
            .map((entry) => normalizeScriptPath(entry.name))
            .filter((scriptPath) => scriptPath.includes('/static/'));

        if (scriptEntries.length > 0) {
            return Array.from(new Set(scriptEntries)).sort();
        }
    } catch (error) {
        console.error('Error reading current script resources:', error);
    }

    return Array.from(document.querySelectorAll('script[src]'))
        .map((element) => normalizeScriptPath(element.getAttribute('src')))
        .filter((scriptPath) => scriptPath.includes('/static/'))
        .sort();
}

const getServerScriptPaths = async () => {
    const response = await fetch(`${window.location.origin}/index.html?__deploy_check=${Date.now()}`, {
        cache: 'no-store',
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        }
    });
    const html = await response.text();
    const scriptRegex = /<script[^>]+src=["']([^"']+)["']/g;
    const scriptPaths = [];
    let match = scriptRegex.exec(html);
    while (match) {
        const scriptPath = normalizeScriptPath(match[1]);
        if (scriptPath.includes('/static/')) {
            scriptPaths.push(scriptPath);
        }
        match = scriptRegex.exec(html);
    }
    return Array.from(new Set(scriptPaths)).sort();
}

const forceReloadWithLatestCode = async () => {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((registration) => registration.unregister()));
        }
        if ('caches' in window) {
            const cacheKeys = await caches.keys();
            await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
        }
    } catch (error) {
        console.error('Error while clearing cached app resources:', error);
    }

    const refreshUrl = new URL(window.location.href);
    refreshUrl.searchParams.set('_deploy_refresh', `${Date.now()}`);
    window.location.replace(refreshUrl.toString());
}

export const checkLatestDeploymentRefresh = async () => {
    const [currentScriptPaths, serverScriptPaths] = await Promise.all([
        Promise.resolve(getCurrentLoadedScriptPaths()),
        getServerScriptPaths()
    ]);

    if (!serverScriptPaths.length || !currentScriptPaths.length) {
        return false;
    }

    const currentSignature = currentScriptPaths.join('|');
    const serverSignature = serverScriptPaths.join('|');
    if (currentSignature !== serverSignature) {
        await forceReloadWithLatestCode();
        return true;
    }
    return false;
}
